export default "__VITE_ASSET__DqmUfBu0__"